import LoadingBar from './LoadingBar';

export default LoadingBar;
